module.exports = __webpack_public_path__ + "static/img/blue-logo.285a0c89.svg";